import {useNuxtApp} from '#app';

export function useSanitizeHtml() {
    const {$sanitizeHtml} = useNuxtApp();

    if (!$sanitizeHtml) {
        throw new Error('useSanitizeHtml: sanitize-html plugin is not activated!');
    }

    return {
        sanitizeHtml: $sanitizeHtml as (s: string) => string,
    };
}
